import screenAlto from "./assets/screen-alto.avif?url"
import screenFactor from "./assets/screen-factor.avif?url"
import screenFlirta from "./assets/screen-flirtagpt.avif?url"
import screenSk from "./assets/screen-sk.avif?url"
import screenTapioca from "./assets/screen-tapioca.avif?url"
import screenTcmg4 from "./assets/screen-tcmg4.avif?url"
import worksScene from "./assets/works-scene.avif?url"

export default [
  {
    name: "works-scene",
    type: "texture",
    path: worksScene,
  },
  {
    name: "screen-alto",
    type: "texture",
    path: screenAlto,
  },
  {
    name: "screen-factor",
    type: "texture",
    path: screenFactor,
  },
  {
    name: "screen-sk",
    type: "texture",
    path: screenSk,
  },
  {
    name: "screen-tapioca",
    type: "texture",
    path: screenTapioca,
  },
  {
    name: "screen-tcmg4",
    type: "texture",
    path: screenTcmg4,
  },
  {
    name: "screen-flirtagpt",
    type: "texture",
    path: screenFlirta,
  },
]
